/* global AFRAME THREE TWEEN PROJECT_VERSION PROJECT_NAME PROJECT_ISSUE_URL */
/**
 * 1. app styles will be extraxted to style/app-theme.css
 *    and not included in final bundle of this entry point!
 */
import './modules/formSubmit.js'
import '../style/app-theme.scss'

const appConfig = require('../app-config')

if (process.env.NODE_ENV !== 'production' && typeof AFRAME !== 'undefined') {
  const info = AFRAME.utils.debug(`${PROJECT_NAME}:info`)
  info('Looks like we are in development mode!')
  info(`Version: ${PROJECT_VERSION}-dev`)
  info(`report issues: ${PROJECT_ISSUE_URL}`)
  info(`A-Frame Version: ${AFRAME.version}`)
  info(`three.js Version: r${THREE.REVISION}`)
  info(`including TWEEN: ${TWEEN._nextId}`)
  console.dir(appConfig)
}

// ServiceWorker is a progressive technology. Ignore unsupported browsers
if ('serviceWorker' in navigator) {
//   console.log('CLIENT: service worker registration in progress.')
//   navigator.serviceWorker.register('/service-worker.js').then(function () {
//     console.log('CLIENT: service worker registration complete.')
//   }, function () {
//     console.log('CLIENT: service worker registration failure.')
//   })
// } else {
//   console.log('CLIENT: service worker is not supported.')
}

(function(){

  window.addEventListener("load", function load(event){
    var aScene = document.querySelector("a-scene");
    var landingDiv = document.querySelector("#background-landing");
    var progressDiv = document.querySelector("#progressDiv");
    var vrnBtn = document.querySelector("#enter-vr");
    var gearvrBtn = document.querySelector("#enter-gearvr");
    var music = document.querySelector("#music");
    var gearvrDevice = AFRAME.utils.device.isGearVR();
    var mobileDevice = AFRAME.utils.device.isMobile();
    var desktopDevice = !AFRAME.utils.device.checkHeadsetConnected();
    var ViveRiftDevice = AFRAME.utils.device.isMobile() && AFRAME.utils.device.checkHeadsetConnected();

    window.removeEventListener("load", load, false); //remove listener, no longer needed

    function onSceneLoaded(){

      if(progressDiv){
        progressDiv.remove();
      }

      if(vrnBtn){
        vrnBtn.style.display = "block";
        vrnBtn.addEventListener("click", entervrhandler);
      }

      if(gearvrBtn){
        gearvrBtn.style.display = "block";
        gearvrBtn.addEventListener("click", entergearvrhandler);
      }

      function entervrhandler() {
          landingDiv.remove();
          aScene.style.display = "block";
          playBackgroundMusic();
          timeoutIntro();
      }

      function entergearvrhandler() {
          landingDiv.style.display = "none";
          aScene.style.display = "block";
          // playBackgroundMusic();          
          document.querySelector('a-scene').enterVR();
          timeoutIntro();
      }

      aScene.addEventListener('enter-vr', function () {
        if(gearvrDevice){
          playBackgroundMusic();
        }
      }); 

      function playBackgroundMusic() {
        music.components.sound.playSound();  
      }

      var introScreen = null;
      var introScreenCardboard = document.getElementById("intro-screen-cardboard");
      var introScreenGearVR = document.getElementById("intro-screen-gearvr");
      var timeout;
      function timeoutIntro() {
        console.log('setTimeout');
        timeout = setTimeout(function() {
          if(introScreen){
            console.log('close Intro after 20s');
            introScreen.emit("closeintro");  
          }
        }, 20000);
      }

      function stopTimeoutIntro() {
          console.log('clearTimeout');
          clearTimeout(timeout);
      }

      if(introScreenCardboard){
        introScreen = introScreenCardboard;
        introScreenCardboard.addEventListener('click', function () {
          this.emit("closeintro"); 
          stopTimeoutIntro();
        });
      }

      if(introScreenGearVR){
        introScreen = introScreenGearVR;
        introScreenGearVR.addEventListener('click', function () {
          this.emit("closeintro"); 
          stopTimeoutIntro();
        });
      }

/*
      var showucaasbtn = document.getElementById("showucaasbtn");
      var ucaascontainer = document.getElementById("ucaascontainer");
      var videoucaas = document.getElementById("avid_ucaas");

      showucaasbtn.addEventListener('click', function () {
        ucaascontainer.setAttribute('visible', 'true');
        ucaascontainer.setAttribute('scale', '1 1 1');
        videoucaas.play();
      }); 
*/
//////////////////////////// DEMOS
    var deviceDemo = document.getElementById("chimedevicedemo");
    // var deviceDemoHide = document.getElementById("chimedevicedemohide");

    var capacityDemo = document.getElementById("chimecapacitydemo");
    // var capacityDemoHide = document.getElementById("chimecapacitydemohide");

    var smartwanDemo = document.getElementById("smartwandemo");
    // var smartwanDemoHide = document.getElementById("smartwandemohide");

    var skillsDemo = document.getElementById("contactcenterskillsdemo");
    // var skillsDemoHide = document.getElementById("contactcenterskillsdemohide");

    var issuesDemo = document.getElementById("contactcenterissuesdemo");
    // var issuesDemoHide = document.getElementById("contactcenterissuesdemohide");

    var retailDemo = document.getElementById("reachretaildemo");
    // var retailDemoHide = document.getElementById("reachretaildemohide");

    var realestateDemo = document.getElementById("reachrealestatedemo");
    // var realestateDemoHide = document.getElementById("reachrealestatedemohide");

      window.demochime1 = function () {
//        capacityDemoHide.emit("hidedemo");        
        deviceDemo.emit("chime-device-demo-play");          
          ga('send', {
            hitType: 'event',
            eventCategory: 'Amazon Chime',
            eventAction: 'play',
            eventLabel: 'Demo - Access Across Devices'
          });
      }
      window.demochime2 = function () {
//        deviceDemoHide.emit("hidedemo");        
        capacityDemo.emit("chime-capacity-demo-play");
          ga('send', {
            hitType: 'event',
            eventCategory: 'Amazon Chime',
            eventAction: 'play',
            eventLabel: 'Demo - High Capacity Collaboration'
          });
      }
      window.bookmarkchime = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'Amazon Chime',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }

      window.democontactcenter1 = function () {
//          issuesDemoHide.emit("hidedemo");
          skillsDemo.emit("contactcenter-skills-demo-play");
          ga('send', {
            hitType: 'event',
            eventCategory: 'Contact Center',
            eventAction: 'play',
            eventLabel: 'Demo - ACD & Skill-based Routing'
          });
      }
      window.democontactcenter2 = function () {
//          skillsDemoHide.emit("hidedemo");
          issuesDemo.emit("contactcenter-issues-demo-play");
          ga('send', {
            hitType: 'event',
            eventCategory: 'Contact Center',
            eventAction: 'play',
            eventLabel: 'Demo - Real-time Sentiment Analysis'
          });
      }
      window.bookmarkcontactcenter = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'Contact Center',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }

      window.demosmartwan = function() {
          smartwanDemo.emit("smartwan-demo-play");          
          ga('send', {
            hitType: 'event',
            eventCategory: 'SmartWan',
            eventAction: 'play',
            eventLabel: 'Demo - Voice Prioritization/QoE'
          });
      }
      window.bookmarksmartwan = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'SmartWan',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }

      window.demovonagereach1 = function () {
//          realestateDemoHide.emit("hidedemo");
          retailDemo.emit("reach-retail-demo-play");
          ga('send', {
            hitType: 'event',
            eventCategory: 'Vonage Reach',
            eventAction: 'play',
            eventLabel: 'Demo - Case Study: Retail'
          });
      }
      window.demovonagereach2 = function () {
//          retailDemoHide.emit("hidedemo");
          realestateDemo.emit("reach-realestate-demo-play");
          ga('send', {
            hitType: 'event',
            eventCategory: 'Vonage Reach',
            eventAction: 'play',
            eventLabel: 'Demo - Case Study: Real Estate'
          });
      }
      window.bookmarkvonagereach = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'Vonage Reach',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }

      window.videocrm = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'CRM Integrations',
            eventAction: 'play',
            eventLabel: 'CRM Video Watched'
          });
      }
      window.bookmarkcrm = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'CRM Integrations',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }
      
      window.videosip = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'SIP Trunking',
            eventAction: 'play',
            eventLabel: 'SIP Trunking Video Watched'
          });
      }
      window.bookmarksip = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'SIP Trunking',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }

      window.videoucaas = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'UCaaS & CPaaS',
            eventAction: 'play',
            eventLabel: 'UCaaS & CPaaS Video Watched'
          });
      }
      window.bookmarkucaas = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'UCaaS & CPaaS',
            eventAction: 'check',
            eventLabel: 'Product Bookmarked'
          });
      }

      window.opentrunk = function () {
          ga('send', {
            hitType: 'event',
            eventCategory: 'Tradeshow Only',
            eventAction: 'open',
            eventLabel: 'Treasure Trunk'
          });
      }

//////////////////////////// END DEMOS

      document.addEventListener("GARREADY", function(e){
        if( gearvrDevice ){
          console.log('--------------------------AFRAME.utils.device.isGearVR ()');
          e.detail.setCustomVariable('GearVR');
        }
        if ( mobileDevice ){
          console.log('--------------------------AFRAME.utils.device.isMobile ()');
          e.detail.setCustomVariable('Cardboard / Mobile');
        }
        if( ViveRiftDevice ){
          console.log('--------------------------AFRAME.utils.device.isMobile() && AFRAME.utils.device.checkHeadsetConnected()');
          e.detail.setCustomVariable('Oculus Rift / HTC Vive');
        }
        if( desktopDevice ){
          console.log('--------------------------Desktop');
          e.detail.setCustomVariable('Desktop');
        }
      });

    };
    if(aScene){
      (aScene.hasLoaded ? onSceneLoaded() : aScene.addEventListener("loaded", onSceneLoaded));
    }
  },false);
})();



// WEBPACK FOOTER //
// ./src/js/app.js